import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTreeNavigation from "vue-tree-navigation";
import firebase from "firebase/app";
import "firebase/analytics";

var firebaseConfig = {
  apiKey: "AIzaSyA7M4Lu9GwAPUB1hu5E6AEjM7HY65FmA8w",
  authDomain: "appitam.firebaseapp.com",
  databaseURL: "https://appitam-default-rtdb.firebaseio.com",
  projectId: "appitam",
  storageBucket: "appitam.appspot.com",
  messagingSenderId: "128425674013",
  appId: "1:128425674013:web:8d81462e6a618c2b588df4",
  measurementId: "G-521JX96V1H"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.use(VueTreeNavigation);

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
